import { useState } from 'react';
import { Toggle } from 'rsuite';
import RModal from '../../../../components/Rsuite/Modal';
import { CustomButton } from '../../../../components/CustomButton';
import { CustomInput as Input } from '../../../../components/CustomInput';
import { CustomSelectPicker as SelectPicker } from '../../../../components/CustomSelectPicker';
import { CustomInputNumber as InputNumber } from '../../../../components/CustomInputNumber';
import { Label } from '../../../../components/Label';
import { Flex } from '../../../../components/Flex/Flex';
import { WizardContainer, WizardBody, Stepper, StepContent } from '../../../../components/Wizard';
import { ConditionSection } from '../ConditionSection';
import { RewardSection } from '../RewardSection/RewardSection';
import {
  selectLoyaltyTypeData,
  selectDurationPresetData,
  durationPresetKeys,
  loyaltyTypesKeys,
  formStateKeys,
} from '../../constants';
import { parseFormToProgram } from '../../utils/parseFormToProgram';
import { conditionSummary, rewardSummary } from '../../utils/programSummary';
import { styles } from '../../styles';

const steps = [
  { key: 'dados', label: 'Dados Gerais' },
  { key: 'regras', label: 'Acúmulo e Recompensa' },
  { key: 'duracao', label: 'Duração e Validade' },
];

const SectionHeader = ({ title }) => {
  return <span style={styles.sectionTitle}>{title}</span>;
};

const ProgramPreview = ({ form }) => {
  const preview = parseFormToProgram(form, 0);

  return (
    <div style={styles.previewBox}>
      <strong>Prévia para o cliente:</strong> {conditionSummary(preview)} →{' '}
      {rewardSummary(preview)}
    </div>
  );
};

export const LoyaltyModal = ({ open, onClose, form, onChange, onSave, saving, isEdit }) => {
  const [activeStep, setActiveStep] = useState('dados');
  const isCashback = form.type === loyaltyTypesKeys.cashback;

  return (
    <RModal
      open={open}
      onClose={onClose}
      size="md"
      title={isEdit ? 'Editar Fidelidade' : 'Cadastrar Fidelidade'}
      footer={
        <>
          <CustomButton onClick={onSave} appearance="primary" disabled={saving}>
            Salvar
          </CustomButton>
          <CustomButton onClick={onClose} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <WizardContainer>
        <WizardBody>
          <Stepper steps={steps} activeKey={activeStep} onSelect={setActiveStep} />

          <StepContent>
            {activeStep === 'dados' && (
              <div style={styles.section}>
                <SectionHeader title="Programa de fidelidade" />

                <Flex>
                  <Input
                    placeholder="Ex: Clube MenuCheff"
                    label="Nome da campanha"
                    value={form.name}
                    onChange={onChange(formStateKeys.name)}
                  />

                  <div>
                    <Label>Tipo de fidelidade</Label>
                    <SelectPicker
                      style={{ width: '100%' }}
                      data={selectLoyaltyTypeData}
                      value={form.type}
                      placeholder="Selecione o tipo"
                      searchable={false}
                      onSelect={onChange(formStateKeys.type)}
                    />
                  </div>
                </Flex>
                <span style={styles.sectionHelper}>
                  Define como o cliente acumula (ex: a cada pedido, um % do valor gasto). A
                  recompensa é escolhida na próxima etapa.
                </span>

                <Input
                  placeholder="Descreva o programa de fidelidade para o cliente"
                  label="Descrição"
                  value={form.description}
                  onChange={onChange(formStateKeys.description)}
                />

                <div style={styles.toggleRow}>
                  <Toggle
                    checkedChildren="Ativo"
                    unCheckedChildren="Inativo"
                    checked={form.status}
                    onChange={onChange(formStateKeys.status)}
                  />
                  <span style={styles.toggleLabel}>Programa ativo para os clientes</span>
                </div>
              </div>
            )}

            {activeStep === 'regras' &&
              (!form.type ? (
                <span style={styles.sectionHelper}>
                  Selecione um tipo de fidelidade na etapa "Dados Gerais" para configurar o
                  acúmulo e a recompensa.
                </span>
              ) : (
                <>
                  <ProgramPreview form={form} />

                  <div style={styles.section}>
                    <SectionHeader title="Como o cliente acumula" />
                    <ConditionSection form={form} onChange={onChange} />
                  </div>

                  {!isCashback && (
                    <div style={styles.section}>
                      <SectionHeader title="Recompensa do cliente" />
                      <RewardSection form={form} onChange={onChange} />
                    </div>
                  )}
                </>
              ))}

            {activeStep === 'duracao' && (
              <>
                <div style={styles.section}>
                  <SectionHeader title="Duração da campanha" />
                  <span style={styles.sectionHelper}>
                    Depois desse prazo, o programa é desativado automaticamente e para de
                    conceder novos benefícios.
                  </span>

                  <SelectPicker
                    style={{ width: '100%' }}
                    data={selectDurationPresetData}
                    value={form.durationPreset}
                    searchable={false}
                    onSelect={onChange(formStateKeys.durationPreset)}
                  />

                  {form.durationPreset === durationPresetKeys.personalizado && (
                    <InputNumber
                      placeholder="Ex: 400"
                      label="Dias de duração"
                      value={form.durationCustomDays}
                      onChange={onChange(formStateKeys.durationCustomDays)}
                    />
                  )}
                </div>

                <div style={styles.section}>
                  <SectionHeader title="Validade do benefício" />
                  <span style={styles.sectionHelper}>
                    Depois de concedido a um cliente, por quanto tempo esse benefício específico
                    continua valendo (diferente da duração da campanha, acima).
                  </span>

                  <InputNumber
                    placeholder="Ex: 30"
                    label="Dias de validade após o benefício ser concedido (opcional)"
                    value={form.validityDays}
                    onChange={onChange(formStateKeys.validityDays)}
                  />
                </div>
              </>
            )}
          </StepContent>
        </WizardBody>
      </WizardContainer>
    </RModal>
  );
};
